import React, { useEffect } from "react";
import Function from "./function";
import "./functions.css";
function Functions(props) {
  async function addtooltip() {
    props.functions.map((content, index) => {
      let el = document.getElementById(`lgmaincat${index}`);
      if (el != null) {
        if (el.scrollWidth - el.offsetWidth >= -1) {
          el.setAttribute("title", content.title);
        } else {
          el.removeAttribute("title");
        }
      }
    });
  }
  useEffect(() => {
    addtooltip();
  }, [props]);

  window.addEventListener("resize", () => {
    addtooltip();
  });

  var i = 0;
  function services() {
    i++;
    if (i % 2 === 1) {
      document.getElementsByClassName("mobile-functions")[0].style.display =
        "block";
    } else {
      document.getElementsByClassName("mobile-functions")[0].style.display =
        "none";
    }
  }
  return (
    <div className="functions" onClick={props.onClick}>
      <button className="mobile-button" onClick={services}>
        Select Service
      </button>
      <div className="mobile-functions">
        <div>
          {props.functions.map((content, index) => {
            return (
              <Function
                value={content}
                key={index}
                id={index}
                describe={props.describe}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
export default Functions;
